import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { bind } from '../Utils/Bind';

export interface IDisplayFilterContainerProps {
    readonly className?: string;
    readonly renderAfter?: React.ReactNode;
    readonly hide?: boolean;
}

@observer
export class DisplayFilterContainer extends React.Component<IDisplayFilterContainerProps> {
    public async componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        document.addEventListener('change', this.updateScroll);
        this.updateScroll();
    }

    public componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
        document.removeEventListener('change', this.updateScroll);
    }

    public render() {
        const { className, children, renderAfter } = this.props;

        return (
            <div className={this.filterClass + className} ref={this.bindElement}>
                <div className="filters-inputs" ref={this.bindScrollElement}>
                    {children}
                </div>

                {renderAfter}
            </div>
        );
    }

    @bind
    private bindElement(element: HTMLDivElement | null) {
        this.inputBoxElement = element;
    }

    @bind
    private bindScrollElement(element: HTMLDivElement | null) {
        this.scrollElement = element;
    }

    @bind
    @action
    private handleClickOutside(event: MouseEvent) {
        const element = event.target as HTMLElement;
        if (this.inputBoxElement?.contains(element)) {
            this.focused = true;
        } else {
            this.focused = false;
        }
    }

    @bind
    @action
    private updateScroll(event?: Event) {
        if (this.scrollElement) {
            this.scrollElement.scrollTo({ left: this.scrollElement.scrollWidth });
        }
    }

    @computed
    private get filterClass() {
        const defaultClass = this.props.hide ? 'display-filter-input-box ' : 'display-filter-input-box show ';
        return this.focused ? defaultClass + ' focus ' : defaultClass;
    }

    @observable
    private focused = false;
    private inputBoxElement: HTMLDivElement | null = null;
    private scrollElement: HTMLDivElement | null = null;
}
